import { useIntl } from 'react-intl';
import ConfirmationModal from '~/components/ConfirmationModal';
import messages from './messages';

type ApplicationOptionsDialogProps = {
  open: boolean;
  handleApplyForShift: (options: { hasVehicle: boolean }) => void;
};

const ApplicationOptionsDialog = (props: ApplicationOptionsDialogProps) => {
  const intl = useIntl();
  return (
    <ConfirmationModal
      open={props.open}
      title={intl.formatMessage(messages.vehicleDialogTitle)}
      text={intl.formatMessage(messages.vehicleDialogContent)}
      onCancel={() => props.handleApplyForShift({ hasVehicle: false })}
      cancelLabel={intl.formatMessage(messages.vehicleDialogNo)}
      onConfirm={() => props.handleApplyForShift({ hasVehicle: true })}
      confirmLabel={intl.formatMessage(messages.vehicleDialogYes)}
    />
  );
};

ApplicationOptionsDialog.displayName = 'ApplicationOptionsDialog';

export default ApplicationOptionsDialog;
